/**
 * About Us Media Cards - Sleek Theme OS 2.0
 */
if (!customElements.get('about-us-cards')) {
  class AboutUsCards extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Optional interactive touch gestures or animation observer
      const cards = this.querySelectorAll('.about-us-card');
      cards.forEach((card) => {
        card.addEventListener('mouseenter', () => {
          card.classList.add('is-hovered');
        });
        card.addEventListener('mouseleave', () => {
          card.classList.remove('is-hovered');
        });
      });
    }
  }

  customElements.define('about-us-cards', AboutUsCards);
}
